import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import sharesTransferExcelModalSteps from '../constants/sharesTransferExcelModalSteps';
import { useSharesTransferExcelModal } from '../context/SharesTransferExcelModalContext';

const SharesTransferExcelModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSharesTransferExcelModal();

  const isPreview = data.step === sharesTransferExcelModalSteps.PREVIEW;
  const hasPreviewErrors = (data.excelPreview?.totalErrors || 0) > 0;
  const canExecute =
    isPreview &&
    Boolean(data.excelPreview?.operations.length) &&
    !hasPreviewErrors;

  const handlePrimaryAction = () => {
    if (isPreview) {
      actions.handleExecuteFromExcel();
    }
  };

  return (
    <Modal.Footer>
      <div className="d-flex justify-content-between align-items-center w-100">
        <div>
          {isPreview && (
            <button
              type="button"
              className="btn btn-lg btn-outline-light"
              onClick={actions.handleBackToUpload}
              disabled={data.isLoading || data.isExecuting}
            >
              {t('BackToUpload')}
            </button>
          )}

          {isPreview && hasPreviewErrors && (
            <span
              className="text-soft small ml-2"
              data-testid="shares-transfer-preview-error-hint"
            >
              {t('SharesTransferExcelCorrectErrorsToContinue')}
            </span>
          )}
        </div>

        {isPreview && (
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={handlePrimaryAction}
            disabled={!canExecute || data.isLoading || data.isExecuting}
            data-testid="shares-transfer-excel-execute-button"
          >
            {t('SharesTransferExcelExecute')}
          </button>
        )}
      </div>
    </Modal.Footer>
  );
};

export default SharesTransferExcelModalFooter;
